import { defineMessages } from 'react-intl'

/**
 * Push notification copy, keyed by backend event name.
 *
 * defineMessages + defaultMessage (same pattern as ToastMessages.ts) means a push
 * that arrives before IntlProvider mounts still renders the English default instead
 * of a raw message id. Placeholders are snake_case to map 1:1 from the envelope params.
 *
 * Invariant: every placeholder used here must be listed in EVENT_REGISTRY.requiredParams
 * for the same event, so a missing param falls back to the server body rather than
 * leaking a visible placeholder.
 */
export const pushNotificationMessages = defineMessages({
  order_created: {
    id: 'app.notifications.order_created',
    defaultMessage: 'New order #{order_id}',
  },
  order_canceled: {
    id: 'app.notifications.order_canceled',
    defaultMessage: 'Order #{order_id} was canceled',
  },
  item_canceled: {
    id: 'app.notifications.item_canceled',
    defaultMessage: 'An item in order #{order_id} was canceled',
  },
  order_updated: {
    id: 'app.notifications.order_updated',
    defaultMessage: 'Order #{order_id} was updated',
  },
  order_status_incomplete: {
    id: 'app.notifications.order_status_incomplete',
    defaultMessage: 'Order #{order_id} is incomplete',
  },
  order_not_delivered: {
    id: 'app.notifications.order_not_delivered',
    defaultMessage: 'Order #{order_id} was not delivered',
  },
  order_acceptance_overdue: {
    id: 'app.notifications.order_acceptance_overdue',
    defaultMessage: '⏰ Your acceptance time is up for order #{order_id}. Tap to accept and start preparing it for pickup before it is reassigned.',
  },
})
